import NextImage from 'next/image';
import { Box, Flex, Text, Heading } from '@opendoor/bricks/core';
import { imgixLoader } from '../../helpers/imgixUrl';

interface StepperCardProps {
  imageUrl: string;
  stepNumber: string;
  header: string;
  description: string;
  alt: string;
}

const StepperCard = (props: StepperCardProps) => (
  <Box maxWidth={['340px', null, '300px', '300px']} mx={4} mt={8} role="group" aria-label="step">
    <NextImage
      loader={imgixLoader}
      width={442}
      height={310}
      layout="responsive"
      src={props.imageUrl}
      alt={props.alt}
    />
    <Flex
      flexDirection={['row', null, 'column', 'column']}
      mt={[5, null, 7, 7]}
      pr={[null, null, 8, 8]}
    >
      <Text color="brand50" fontWeight="bold" fontSize="s00" width={['40%', null, '100%', '100%']}>
        STEP {props.stepNumber}
      </Text>
      <Box>
        <Heading size="h4" fontSize={['s1', null, 's2', 's2']} mb={[4, null, 5, 5]}>
          {props.header}
        </Heading>
        <Text fontSize={['s0', null, 's1', 's1']} lineHeight="bodyTighter">
          {props.description}
        </Text>
      </Box>
    </Flex>
  </Box>
);

const HowItWorks = () => (
  <Box mx="auto" mt={[9, null, 8, 8]} maxWidth={['95%', null, '960px', '960px']} id="how-it-works">
    <Box textAlign="center">
      <Box fontSize={['s3', null, null, 's4', 's5']} fontWeight="bold" mb={6}>
        <Heading size="h4" lineHeight="bodyTighter">
          Sell your home.
        </Heading>
        <Heading size="h4" color="brand50" lineHeight="bodyTighter">
          Skip the hard parts.
        </Heading>
      </Box>
      <Text
        width={['95%', '450px', '500px']}
        mx="auto"
        lineHeight="body"
        fontSize={['s0', null, 's1', 's1']}
      >
        Here's how we cut out the unnecessary steps to make selling your home easy, fast, and
        stress-free.
      </Text>
    </Box>
    <Flex
      flexDirection={['column', null, 'row', 'row']}
      alignItems={['center', null, 'flex-start', 'flex-start']}
      justifyContent="space-between"
      mt={[null, null, 7, 7]}
    >
      <StepperCard
        imageUrl="8911bcea814a4fe9b524ae3251821251.png"
        stepNumber="1"
        header="Get an offer in minutes"
        description="See your preliminary offer in just a few easy steps."
        alt="Person viewing preliminary offer on tablet"
      />
      <StepperCard
        imageUrl="a839f69c2046464ba7d32206e0c522a5.png"
        stepNumber="2"
        header="Do a video walkthrough"
        description="Show us your home so we can make our best offer."
        alt="A video walkthrough occurring on a mobile device"
      />
      <StepperCard
        imageUrl="ff780f3dc07f47aab6170f9802a798c0.png"
        stepNumber="3"
        header="Close and move, stress-free"
        description="Choose when you want to close. Get paid within days."
        alt="Family standing at their front door"
      />
    </Flex>
  </Box>
);

export default HowItWorks;
